import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
  ListItemIcon,
  SvgIcon,
} from '@mui/material';
import {
  AdminIcon,
  ArchiveIcon,
  RequestIcon,
  StarIcon,
  QuoteIcon,
  ClockIcon,
  RejectedIcon,
} from 'Components/Icons';
import Grid from '@mui/material/Grid2';
import { UserType } from 'shared/types/User.types';
import FifaLogo from '../../../App/Assets/images/LHS/fifa-logo.svg';

const classes = {
  drawer: {
    width: 250,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: 250,
      boxSizing: 'border-box',
      boxShadow: '10px 0px 10px #0000001A',
    },
  },
};

const LHS: React.FC<{ user: UserType }> = ({ user }): React.ReactElement => {
  const location = useLocation();

  return (
    <Drawer
      variant="permanent"
      anchor="left"
      sx={classes.drawer}
      PaperProps={{
        style: {
          backgroundColor: '#326295',
          borderRight: 0,
        },
      }}>
      <Stack
        justifyContent="space-between"
        sx={{
          height: '100%',
        }}>
        <List>
          <ListItem
            sx={{ mb: '30px', justifyContent: 'flex-start', gap: '14px' }}
            component={Link}
            to="/new-brief">
            <img src={FifaLogo} alt="FIFA logo" />
          </ListItem>
          <ListItem sx={{ borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>
            <Typography sx={{ fontWeight: 700 }} variant="button">
              BRIEFING PLATFORM
            </Typography>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/live-projects"
              selected={location.pathname.startsWith('/live-projects')}
              alignItems="center">
              <ListItemIcon>
                <SvgIcon>
                  <StarIcon />
                </SvgIcon>
              </ListItemIcon>
              <ListItemText primary="Live projects" />
            </ListItemButton>
          </ListItem>
          {/* <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/quote-requests"
              selected={location.pathname.startsWith('/quote-requests')}
              alignItems="center">
              <ListItemIcon>
                <SvgIcon>
                  <QuoteIcon />
                </SvgIcon>
              </ListItemIcon>
              <ListItemText primary="Quote Requests" />
            </ListItemButton>
          </ListItem> */}
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/new-brief"
              selected={location.pathname.startsWith('/new-brief')}
              alignItems="center">
              <ListItemIcon>
                <SvgIcon>
                  <RequestIcon />
                </SvgIcon>
              </ListItemIcon>
              <ListItemText primary="New Brief" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/pending-projects"
              selected={location.pathname.startsWith('/pending-projects')}
              alignItems="center">
              <ListItemIcon>
                <SvgIcon>
                  <ClockIcon />
                </SvgIcon>
              </ListItemIcon>
              <ListItemText primary="Pending projects" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/rejected-projects"
              selected={location.pathname.startsWith('/rejected-projects')}
              alignItems="center">
              <ListItemIcon>
                <SvgIcon>
                  <RejectedIcon />
                </SvgIcon>
              </ListItemIcon>
              <ListItemText primary="Rejected projects" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/archive"
              selected={location.pathname.startsWith('/archive')}
              alignItems="center">
              <ListItemIcon>
                <SvgIcon>
                  <ArchiveIcon />
                </SvgIcon>
              </ListItemIcon>
              <ListItemText primary="Archive" />
            </ListItemButton>
          </ListItem>

          {user?.is_super_admin && (
            <ListItem disablePadding>
              <ListItemButton
                component={Link}
                to="/admin"
                selected={location.pathname.startsWith('/admin')}
                alignItems="center">
                <ListItemIcon>
                  <SvgIcon>
                    <AdminIcon />
                  </SvgIcon>
                </ListItemIcon>
                <ListItemText primary="Admin" />
              </ListItemButton>
            </ListItem>
          )}
        </List>

        <List>
          <Grid container justifyContent="center">
            <Grid>
              <Typography
                sx={{
                  color: '#fff',
                  fontSize: '12px',
                }}>
                Powered by
              </Typography>
            </Grid>
            <Grid>
              <img
                style={{ height: '18px', marginLeft: '10px' }}
                alt="Bylder Logo"
                src="/images/logo/bylder-logo.svg"
              />
            </Grid>
          </Grid>
        </List>
      </Stack>
    </Drawer>
  );
};

export default LHS;
